export function toggleArray<T>(value: T, values: T[]) {
  if (values.includes(value)) {
    return values.filter((v) => v !== value);
  } else {
    return [...values, value];
  }
}
